export const CONTACT_NAME_FIELD = 'name';
export const CONTACT_EMAIL_FIELD = 'email';
export const CONTACT_PHONE_FIELD = 'phone';
